import { windowFactory } from '../factories/window.factory';
import { sanitizeUrl } from './sanitizeUrl';

interface AsyncLoadParam {
  id: string;
  url: string;
  onLoad?(): void;
  onError?(): void;
  attributes?: { [key: string]: string };
  isAppend?: boolean;
}

export async function asyncLoadLibrary({
  id,
  url,
  onLoad,
  onError,
  attributes = {},
  isAppend = true,
}: AsyncLoadParam): Promise<any> {
  let rv: Promise<any>;

  const windowInstance = windowFactory();
  const existing = windowInstance.document.querySelector(`script[id="${id}"]`);

  if (existing) {
    rv = Promise.resolve(existing);
  } else {
    rv = new Promise((resolve, reject) => {
      const script: HTMLScriptElement =
        windowInstance.document.createElement('script');

      script.id = id;
      script.src = sanitizeUrl(url);
      Object.keys(attributes).forEach((key) => {
        script.setAttribute(key, attributes[key]);
      });

      script.onload = () => {
        onLoad?.();

        setTimeout(() => {
          resolve(script);
        });
      };

      script.onerror = () => {
        onError?.();

        setTimeout(() => {
          reject(script);
        });
      };

      if (isAppend) {
        windowInstance.document.body.appendChild(script);
      } else {
        prependScript(script);
      }
    });
  }
  return rv;
}

function prependScript(script: HTMLScriptElement) {
  const windowInstance = windowFactory();
  const firstLoadedScript =
    windowInstance.document.getElementsByTagName('script')[0];

  firstLoadedScript.parentNode.insertBefore(script, firstLoadedScript);
}
